<div fxLayout="column" fxLayoutAlign="center center" class="neutral-theme">
  @if (isPersonLoaded && areEmailPrefsLoaded) {
    <div class="main-container">
      @if (displayOptedIn) {
        <div>
          <h1 class="title">{{ optedInTitle }}</h1>
          <p>
            You are currently subscribed to emails from
            <strong>{{ tenantName }}</strong
            >.
          </p>
          <p>
            These emails include invitations to future opportunities, form and
            feedback invitations, team and group emails, and other forms of
            communication and coordination.
          </p>
          <p>
            If you no longer wish to receive these emails, click the button
            below.
          </p>
          <div class="action-buttons">
            <button
              mat-flat-button
              appThrottleClick
              (throttledClick)="unsubscribe()"
            >
              Unsubscribe
            </button>
          </div>
        </div>
      }
      @if (!displayOptedIn) {
        <div>
          <h1 class="title">{{ optedOutTitle }}</h1>
          <p>
            You will no longer receive most emails from
            <strong>{{ tenantName }}</strong> through the Lineup platform.
          </p>
          <p>
            These emails include invitations to future opportunities, form and
            feedback invitations, team and group emails, and other forms of
            communication and coordination.
          </p>
          <p>
            If you changed your mind or made a mistake, you can opt back in by
            clicking the button below.
          </p>
          <div class="action-buttons">
            <button
              mat-flat-button
              appThrottleClick
              (throttledClick)="resubscribe()"
            >
              Re-subscribe to emails
            </button>
          </div>
        </div>
      }
    </div>
  }
</div>
